import { Layout } from 'react-grid-layout';
import { WidgetType } from '../types/types';

export const getWidgetsSortedByLayout = (widgets: WidgetType[], layout: Layout[]) => {
  const layoutMap = new Map(layout.map((item) => [item.i, item]));

  return [...widgets].sort((a, b) => {
    const la = layoutMap.get(a.id);
    const lb = layoutMap.get(b.id);

    if (!la || !lb) return 0;

    if (la.y !== lb.y) return la.y - lb.y;
    return la.x - lb.x;
  });
};
